import { useSearchParams } from "react-router"
import { useSupplierAudit } from "../../../api/suppliersApi"
import { AuditTrail } from "../../shared/AuditTrail"

export function SupplierAuditSection() {
  const [searchParams] = useSearchParams()
  const id = searchParams.get("id")

  const { data, hasNextPage, fetchNextPage, isLoading, isFetchingNextPage } =
    useSupplierAudit(id, { limit: 20 })

  const events = data?.pages.flatMap((p) => p.items) ?? []

  return (
    <AuditTrail
      events={events}
      isLoading={isLoading}
      hasMore={!!hasNextPage}
      isFetchingMore={isFetchingNextPage}
      onLoadMore={fetchNextPage}
    />
  )
}
